import Vue from 'vue'
import textField from './fields/TextField';
import numberField from './fields/NumberField';
import autoComplete from './fields/AutoComplete';
import radioField from './fields/RadioField';
import checkboxField from './fields/CheckboxField';
import selectField from './fields/SelectField';
import labelField from './fields/LabelField';
import datePickerField from './fields/DatePicker';
import timePickerField from './fields/TimePicker';
import avatarUpload from './fields/AvatarUpload';
import filesList from './fields/FilesList';
import fileUpload from './fields/FileUpload';
import button from './fields/Button'
import confirmButton from './fields/ConfirmButton'
import switchInput from './fields/Switch'
import fieldContainer from './layout/FieldContainer'
import storageSingleFile from './fields/StorageSingleFile'
import storageMultipleFiles from './fields/StorageMultipleFiles'

Vue.component('dg-field-container', fieldContainer);
Vue.component('dg-text-field', textField);
Vue.component('dg-number-field', numberField);
Vue.component('dg-select-field', selectField);
Vue.component('dg-radio-field', radioField);
Vue.component('dg-checkbox-field', checkboxField);
Vue.component('dg-label-field', labelField);
Vue.component('dg-date-picker-field', datePickerField);
Vue.component('dg-time-picker-field', timePickerField);
Vue.component('dg-button', button);
Vue.component('dg-switch', switchInput);
Vue.component('dg-confirm-button', confirmButton);
Vue.component('dg-avatar-upload', avatarUpload);
Vue.component('dg-files-list', filesList);
Vue.component('dg-file-upload', fileUpload);
Vue.component('dg-auto-complete-field', autoComplete);
Vue.component('dg-storageSingleFile', storageSingleFile);
Vue.component('dg-storageMultipleFiles', storageMultipleFiles);
